import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleWorkClick = (e) => {
        e.preventDefault();
        setMenuOpen(false); // Fermer le menu après le clic
        if (location.pathname === '/') {
            const element = document.getElementById('work');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.location.href = '/#work';
        }
    };

    const handleLinkClick = () => {
        setMenuOpen(false); // Fermer le menu après le clic
    };

    return (
        <header className="header">
            <Link to="/" className='header-links-simon'>Simon</Link>
            <button className="menu-icon" onClick={toggleMenu}>
                &#9776;
            </button>
            <div className={`links ${menuOpen ? 'open' : ''}`}>
                <a href="/#work" className='header-links' onClick={handleWorkClick}>Work</a>
                <Link to="/about" className='header-links' onClick={handleLinkClick}>About</Link>
            </div>
        </header>
    );
};

export default Header;